export default Empresas;

/** @ngInject */
function Empresas(Api) {
  var vm = this;
  var empresas = [];

  vm.LIMIT = 20;
  vm.limparFiltro = limparFiltro;
  vm.buscarEmpresas = buscarEmpresas;
  vm.obterEmpresasCache = () => empresas;
  vm.limparCache = () => empresas = [];
  vm.buscarDadosEmpresa = buscarDadosEmpresa;

  limparFiltro();

  function limparFiltro() {
    vm.filtro = {
      nome: '',
      local: ''
    };
  }

  function buscarEmpresas(filtro) {
    return Api
      .buscarDados('TransportadorasDivulgacao', 'buscarEmpresas', {filtro: filtro})
      .then(function (data) {
        empresas = data || [];
        return empresas;
      });
  }

  function buscarDadosEmpresa(filtro) {
    return Api.buscarDados('TransportadorasDivulgacao', 'obterDadosEmpresa', {filtro: filtro});
  }
}



/** WEBPACK FOOTER **
 ** ./common/services/empresas.service.ts
 **/